"use client";
import React, { useEffect, useMemo, useState } from "react";
import { useResponsive } from "@/client/hooks/useResponsive";
import { LandingDesktop } from "./LandingDesktop";
import { LandingMobile } from "./LandingMobile";
import classNames from "classnames";
import { Display } from "@/client/foundations/Typography";
import { ImageType } from "@/types/app.type";

export interface LandingProps {
  /**
   * The heading of the Landing.
   * @type string
   * @required
   */
  heading: string;
  /**
   * The video source used as background of the Landing.
   * @type string
   * @required
   */
  video: string;
  /**
   * The images source the Card.
   * @type ImageType[]
   * @optional
   */
  image?: ImageType;
  /**
   * The mobile image placeholder.
   * @type ImageType[]
   * @optional
   */
  mobileImage?: ImageType;
  /**
   * The video minimum height.
   * @type string
   * @required
   */
  minHeight?: string;
  /**
  * The video source used as background of the Landing.
   * @type string
   * @required
   */
  mobileVideo?: string;
  /**
  * Mute Video.
   * @type string
   * @required
   */
  muted?: boolean;
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;

  blurOnLoad?: boolean;
  restrictHeight?: boolean
}

export default function Landing({ minHeight, mobileVideo, restrictHeight = true, ...props }: LandingProps) {
  const { isMd } = useResponsive();
  const [isBuffering, setIsBuffering] = useState(true);

  useEffect(() => {
    setIsBuffering(true);
  }, []);
  const heading: any = useMemo(() => {
    return (props.heading ?
      (<Display
        size="xl"
        component="h1"
        color={isMd ? "text-base-white" : "text-interactive-black"}
        className={classNames("block md:hidden", {
          "py-3 px-2": !isMd,
          "!block h-fit w-fit absolute px-8 top-0 left-0 bottom-0 right-0 m-auto z-0 text-center break-normal":
            !isBuffering && isMd,
        })}
      >
        {props.heading}
      </Display>) : ''
    );
  }, [isBuffering, isMd, props.heading]);

  console.log("isMd ---", isMd)

  return isMd ? (
    <LandingDesktop
      video={props.video}
      restrictHeight={restrictHeight}
      mobileVideo={mobileVideo || props?.video}
      image={props.image}
      heading={heading}
      isBuffering={isBuffering}
      minHeight={minHeight || '100px'}
      onBuffer={() => setIsBuffering(false)}
      animated={props.animated ?? false}
      animation={props.animation ?? ''}
      muted={props?.muted}
      blurOnLoad={props?.blurOnLoad}
    />
  ) : (
    <LandingMobile
      video={mobileVideo ? mobileVideo : props.video}
      image={props?.mobileImage ? props?.mobileImage : props.image}
      heading={heading}
      isBuffering={isBuffering}
      onBuffer={() => setIsBuffering(false)}
      animated={props.animated ?? false}
      animation={props.animation ?? ''}
      muted={props?.muted}
      blurOnLoad={props?.blurOnLoad}
    />
  );
}
